import {
    DeleteForeverRounded,
    PlayCircleFilledWhiteOutlined,
    ThumbUpRounded,
    YouTube,
} from '@mui/icons-material';
import {
    Button,
    CardContent,
    Grid,
    IconButton,
    Modal,
    Stack,
    Typography,
} from '@mui/material';
import moment from 'moment';
import { useSnackbar } from 'notistack';
import React, { useState } from 'react';
import ShowMoreText from 'react-show-more-text';
import { useDeleteListDataMutation } from '../../api/apiSlice';
import fbThumbnail1 from '../../assets/fbThumbnail1.jpeg';
import fbThumbnail2 from '../../assets/fbThumbnail2.jpeg';
import fbThumbnail3 from '../../assets/fbThumbnail3.jpeg';
import useSettings from '../../hooks/useSettings';
import { useFeedStyles } from '../../screens/guest/GuestFeedRouteScreen';
import { fbEmbed, isYoutube, y2Embed, y2Thmbnail } from '../../utils/embed';
import errorSnackbar from '../../utils/errorSnackbar';
import ConfirmSheet from './ConfirmSheet';

export const fbThumbnail = [fbThumbnail1, fbThumbnail2, fbThumbnail3][
    Math.floor(Math.random() * 3)
];

export default function ItemPastorService({ service, onDelete }) {
    const [modalOpen, setModalOpen] = useState(false);
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);

    const { enqueueSnackbar } = useSnackbar();
    const { layout } = useSettings();
    const classes = useFeedStyles();

    const spaced = layout === 'spaced';
    const [deleteItem, { isLoading }] = useDeleteListDataMutation();

    const {
        id: serviceId,
        title,
        name,
        date,
        description,
        stream,
        dates,
        post,
    } = service;

    return (
        <>
            <Grid item xs={12} className={classes.grid}>
                <div className={`${spaced && 'd-flex'} px-2 py-3`}>
                    <div style={{ flex: 1 }}>
                        <CardContent className="py-0">
                            <div className="d-flex align-items-center justify-content-between">
                                <Typography
                                    component="span"
                                    className="text-lowercase"
                                    variant="body2"
                                >
                                    {date
                                        ? moment(date).fromNow()
                                        : moment(dates?.updated).fromNow()}
                                </Typography>
                                <Button
                                    startIcon={<DeleteForeverRounded />}
                                    disabled={isLoading}
                                    color="secondary"
                                    onClick={() => setDeleteModalOpen(true)}
                                >
                                    Delete
                                </Button>
                                <ConfirmSheet
                                    open={deleteModalOpen}
                                    isLoading={isLoading}
                                    onCancel={() => setDeleteModalOpen(false)}
                                    onConfirm={async () => {
                                        const { data, error } =
                                            await deleteItem({
                                                list: `/op/services/${serviceId}`,
                                            });

                                        errorSnackbar(error, enqueueSnackbar);

                                        if (data) {
                                            enqueueSnackbar('Service deleted');
                                            onDelete(true);
                                        }

                                        setDeleteModalOpen(false);
                                    }}
                                />
                            </div>
                            <Typography
                                style={{ textTransform: 'capitalize' }}
                                className="fw-bold mt-2 mb-1"
                            >
                                {(title || name)?.toLowerCase()}
                            </Typography>
                            <ShowMoreText lines={2} more="more" less="less">
                                {description || post || ' '}
                            </ShowMoreText>
                            {stream && (
                                <div
                                    className={classes.stream}
                                    style={{
                                        backgroundImage: isYoutube(stream)
                                            ? `url(${y2Thmbnail(stream)})`
                                            : `url(${fbThumbnail})`,
                                        height: spaced
                                            ? ((window.innerWidth - 112) * 9) /
                                              16
                                            : ((window.innerWidth - 64) * 9) /
                                              16,
                                    }}
                                >
                                    <IconButton
                                        onClick={() => setModalOpen(true)}
                                    >
                                        {isYoutube(stream) ? (
                                            <YouTube
                                                color="secondary"
                                                className={classes.icon}
                                            />
                                        ) : (
                                            <PlayCircleFilledWhiteOutlined
                                                sx={{ color: 'white' }}
                                                className={classes.icon}
                                            />
                                        )}
                                    </IconButton>
                                </div>
                            )}
                            <Stack
                                sx={{ mt: 1 }}
                                direction="row"
                                className="align-items-center justify-content-between"
                            >
                                <div className="d-flex align-items-center">
                                    <ThumbUpRounded
                                        className="text-white"
                                        sx={{
                                            mr: 0.5,
                                            width: 16,
                                            height: 16,
                                            bgcolor: 'primary.main',
                                            padding: 0.2,
                                            borderRadius: 1,
                                        }}
                                    />
                                    <Typography variant="body2">
                                        {service?.interaction?.likes || 0}
                                    </Typography>
                                </div>

                                <Typography variant="body2">
                                    0 Shares
                                </Typography>
                            </Stack>
                        </CardContent>
                    </div>
                </div>

                <Modal open={modalOpen} onClose={() => setModalOpen(false)}>
                    <div className={classes.modal}>
                        <iframe
                            className={classes.iframe}
                            src={
                                isYoutube(stream)
                                    ? y2Embed(stream)
                                    : fbEmbed(stream)
                            }
                            title={title}
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                        ></iframe>
                    </div>
                </Modal>
            </Grid>
        </>
    );
}
